import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSession } from "../context/SessionContext";
import { CHECK_SESSION } from "../api/apiAuth";
import Layout from "../layouts/Layout";

const PrivateRoute = ({ children }) => {
	const { setUser } = useSession();
	const navigate = useNavigate();

	useEffect(() => {
		const verify = async () => {
			try {
				await CHECK_SESSION();
				const userString = localStorage.getItem('user');
				const user = userString ? JSON.parse(userString) : null;
				setUser(user);
			} catch (error) {
				toast.error("Sesión no válida");
				navigate("/login");
			}
		};

		verify();
	}, [navigate, setUser]);

	useEffect(() => {
		document.title = "Documentos RS";
	}, []);

	return <Layout>{children}</Layout>;
};

export default PrivateRoute;
